var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1546",
    "data-name": "Group 1546",
    transform: "translate(-2149 -4650)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    transform: "translate(2149 4650)",
    fill: "rgba(255,255,255,0)",
    stroke: "#5dadae",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M12.227,30.9.527,19.2a1.8,1.8,0,0,1,0-2.546L3.073,14.1a1.8,1.8,0,0,1,2.546,0L13.5,21.986,30.382,5.1a1.8,1.8,0,0,1,2.546,0L35.473,7.65a1.8,1.8,0,0,1,0,2.546l-20.7,20.7A1.8,1.8,0,0,1,12.227,30.9Z",
    transform: "translate(2168.5 4669.5)",
    fill: "#5dadae"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmeIcon);
export default __webpack_public_path__ + "static/media/confirme-icon.16475b81e93d44a951008120807d7540.svg";
export { ForwardRef as ReactComponent };